import type { DefaultPrivacyLevel } from '@datadog/browser-rum';

import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

import { getConfig } from '../global-config';

export function initDatadog() {
  const { datadog } = getConfig();

  datadogRum.init({
    applicationId: datadog.applicationId,
    clientToken: datadog.clientToken,
    site: datadog.site,
    service: datadog.service,
    env: datadog.env,
    sessionSampleRate: datadog.sessionSampleRate,
    sessionReplaySampleRate: datadog.sessionReplaySampleRate,
    trackUserInteractions: datadog.trackUserInteractions,
    trackResources: datadog.trackResources,
    trackLongTasks: datadog.trackLongTasks,
    defaultPrivacyLevel: datadog.defaultPrivacyLevel as DefaultPrivacyLevel,
  });

  datadogRum.startSessionReplayRecording();

  datadogLogs.init({
    clientToken: datadog.clientToken,
    site: datadog.site,
    service: datadog.service,
    env: datadog.env,
    forwardErrorsToLogs: datadog.forwardErrorsToLogs,
  });
}
